var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTech({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0691 16.3502C12.6603 16.463 12.2381 16.52 11.814 16.5197C9.21635 16.5197 7.10742 14.4108 7.10742 11.8131C7.10742 9.2155 9.21635 7.10657 11.814 7.10657C12.2485 7.10657 12.6695 7.16558 13.0691 7.27608V16.3502Z",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6587 7.42039C20.5252 7.42039 21.2276 6.71798 21.2276 5.85152C21.2276 4.98506 20.5252 4.28265 19.6587 4.28265C18.7923 4.28265 18.0898 4.98506 18.0898 5.85152C18.0898 6.71798 18.7923 7.42039 19.6587 7.42039Z",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6587 13.382C20.5252 13.382 21.2276 12.6796 21.2276 11.8131C21.2276 10.9467 20.5252 10.2443 19.6587 10.2443C18.7923 10.2443 18.0898 10.9467 18.0898 11.8131C18.0898 12.6796 18.7923 13.382 19.6587 13.382Z",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0686 11.8131H18.0889",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6587 19.3437C20.5252 19.3437 21.2276 18.6413 21.2276 17.7748C21.2276 16.9083 20.5252 16.2059 19.6587 16.2059C18.7923 16.2059 18.0898 16.9083 18.0898 17.7748C18.0898 18.6413 18.7923 19.3437 19.6587 19.3437Z",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0889 5.85152H16.5201L14.6374 8.36165H13.0686M18.0889 17.7748H16.5201L14.6374 15.2646H13.0686M13.0686 2.40002V21.2263H10.5584L10.3041 19.1921C9.34567 18.9967 8.45318 18.6191 7.66451 18.097L6.04491 19.3567L4.26997 17.5817L5.52965 15.9621C5.00755 15.1736 4.62989 14.2811 4.4346 13.3225L2.40039 13.0682V10.558L4.4346 10.3038C4.62997 9.34531 5.00759 8.45282 5.52965 7.66415L4.26997 6.04454L6.04491 4.2696L7.66451 5.52928C8.45307 5.00719 9.34559 4.62953 10.3041 4.43424L10.5584 2.40002H13.0686Z",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTech);
export default __webpack_public_path__ + "static/media/tech.f0419264d937fc4614d9542a77987ff9.svg";
export { ForwardRef as ReactComponent };